function toogleMenuBurguer() {
    const buttonBurguer = document.getElementById("nav-button-burguer-menu");
    const buttonClose = document.querySelector(".nav-menu-mobile #nav-button-icon-close");
    const navMenu = document.getElementById("nav-menu-mobile");

    if (buttonBurguer) {
        buttonBurguer.addEventListener("click", function() {
            if (navMenu) {
                navMenu.style.left = 0;
            }
        });
    }

    if (buttonClose) {
        buttonClose.addEventListener("click", function() {
            if (navMenu) {
                navMenu.style.left = "100%";
            }
        });
    }
}

function toogleItemNav() {
    const itemNav = document.querySelectorAll("header .nav-menu-mobile ul.nav-link li.nav-item");

    if (itemNav.length > 0) {
        for (let i = 0; i < itemNav.length; i++) {
            itemNav[i].addEventListener("click", function() {
                itemNav[i].classList.toggle("active");

                for (let j = 0; j < itemNav.length; j++) {
                    if (j !== i) {
                        itemNav[j].classList.remove("active");
                    }
                }
            });
        }
    }
}

function toggleSearch() {
    const iconSearch = document.querySelector("header #icon-search");
    if (iconSearch) {
        const openSearch = iconSearch.querySelector(".search-open");
        const closeSearch = iconSearch.querySelector(".search-close");
        const wrapSearch = document.querySelector("header .nav-search");

        if (openSearch) {
            openSearch.addEventListener("click", function() {
                if (wrapSearch) {
                    wrapSearch.classList.add("active");
                }

                iconSearch.style.background = "#ffffff";
                openSearch.style.display = "none";
                if (closeSearch) {
                    closeSearch.style.display = "flex";
                }
            });
        }

        if (closeSearch) {
            closeSearch.addEventListener("click", function() {
                if (wrapSearch) {
                    wrapSearch.classList.remove("active");
                }

                iconSearch.style.background = "transparent";
                closeSearch.style.display = "none";
                if (openSearch) {
                    openSearch.style.display = "flex";
                }
            });
        }

        // nav-item
        const itemNav = document.querySelectorAll("header .nav-menu-desktop ul.nav-link li.nav-item");

        if (itemNav.length > 0) {
            for (let i = 0; i < itemNav.length; i++) {
                itemNav[i].addEventListener("mouseover", function() {
                    // hidden search
                    if (wrapSearch) {
                        wrapSearch.classList.remove("active");
                    }

                    iconSearch.style.background = "transparent";
                    if (closeSearch) {
                        closeSearch.style.display = "none";
                    }
                    if (openSearch) {
                        openSearch.style.display = "flex";
                    }
                });
            }
        }
    }
}

function init() {
    toogleMenuBurguer();
    toogleItemNav();
    toggleSearch();

    const navMenuDesktop = document.querySelector(".nav-menu-desktop");
    if (navMenuDesktop) {
        const itemsDesktop = navMenuDesktop.querySelectorAll(".nav-item > .wrap a");
        const location = window.location.pathname;
        const currentSegment = location
            .replace(/\/$/, "")
            .split("/")
            .pop()
            .replace(/\.html$/, "")
            .toLowerCase();

        if (itemsDesktop.length > 0) {
            for (let i = 0; i < itemsDesktop.length; i++) {
                const linkPath = new URL(itemsDesktop[i].href).pathname;
                const linkSegment = linkPath
                    .replace(/\/$/, "")
                    .split("/")
                    .pop()
                    .replace(/\.html$/, "")
                    .toLowerCase();

                if (linkSegment === currentSegment) {
                    itemsDesktop[i].classList.add("active");
                }
            }
        }
    }

    const navMenuMobile = document.querySelector(".nav-menu-mobile");
    if (navMenuMobile) {
        const itemsMobile = navMenuMobile.querySelectorAll(".nav-item > .wrap a");
        const location = window.location.pathname;
        const currentSegment = location
            .replace(/\/$/, "")
            .split("/")
            .pop()
            .replace(/\.html$/, "")
            .toLowerCase();

        if (itemsMobile.length > 0) {
            for (let i = 0; i < itemsMobile.length; i++) {
                const linkPath = new URL(itemsMobile[i].href).pathname;
                const linkSegment = linkPath
                    .replace(/\/$/, "")
                    .split("/")
                    .pop()
                    .replace(/\.html$/, "")
                    .toLowerCase();

                if (linkSegment === currentSegment) {
                    itemsMobile[i].closest(".nav-item").classList.add("active-bar");
                }
            }
        }
    }
}

export default { init };
